// extracted by mini-css-extract-plugin
module.exports = {"root":"SdkVideo_root__1EPgv"};